import { FlowNode } from "../components/types";
import { Edge } from "@xyflow/react";
import ELK from 'elkjs/lib/elk.bundled.js';
const elk = new ELK();

interface ElkNodePos {
  id: string;
  x?: number;
  y?: number;
}

export async function layoutNodes(nodes: FlowNode[], edges: Edge[]): Promise<FlowNode[]> {
  const elkNodes = nodes.map(n => ({ id: n.id, width: 100, height: 200 }));
  const elkEdges = edges.map(e => ({ id: e.id, sources: [e.source], targets: [e.target] }));

  const graph = {
    id: "root",
    layoutOptions: {
      "elk.algorithm": "layered",
      "elk.direction": "DOWN",
      "elk.spacing.nodeNode": "15",
      "elk.spacing.edgeNode": "1",
      "elk.layered.mergeEdges": "true"
    },
    children: elkNodes,
    edges: elkEdges
  };

  const result = await elk.layout(graph);
  const laidOut: ElkNodePos[] = result.children ?? []; // explicitly typed

  return nodes.map(n => {
    const nodePos = laidOut.find((c: ElkNodePos) => c.id === n.id);
    return {
      ...n,
      position: nodePos
        ? { x: nodePos.x ?? 0, y: nodePos.y ?? 0 }
        : { x: 0, y: 0 },
    };
  });
}
